<template>
    <div class="mainx font-inter d-flex flex-column" style="gap: 24px">
      <div>
        <BaseHeader :title="$t('views.seller.reports.text_1444')"></BaseHeader>
        <b-breadcrumb
          :items="[{ text: 'Dashboard', href: '/dashboard' }, { text: $t('views.seller.reports.text_1428'), href: '/relatorios' }, { text: $t('views.seller.reports.text_1444') }]"
          class="bg-white m-0 p-0"></b-breadcrumb>
      </div>
      <div class="divider my-0"></div>
  
      <!-- Filters -->
      <div class="filters d-flex">
        <div class="multiselect-container col-4 p-0">
          <BaseSearchSelect 
            id="product-filter"
            v-model="selectedProducts"
            name="product"
            label="name"          
            track-by="id"
            deselect-label=""
            selectLabel=""
            selectedLabel=""
            :options="productsOptions" 
            :placeholder="$t('views.seller.reports.text_1430')"
            :allow-empty="true"
            :multiple="false" 
            :searchable="true"
            :options-limit="10"
            :loading="loadingProducts"
            @search-change="searchProducts"
            class="new-style"
          >
            <span slot="noOptions">
              {{ $t("views.seller.reports.text_1330") }}
            </span>
            <span slot="noResult">
              {{ $t("views.seller.reports.text_1331") }}
            </span>
          </BaseSearchSelect>
        </div>
        <b-col cols="2" class="p-0 pl-2">
          <BaseSearchSelect
            v-model="filterSearch.monthYear"
            name="monthYear"
            label="name"   
            track-by="id"
            deselect-label=""
            selectLabel=""
            selectedLabel=""
            placeholder="Mês/ano"
            :options="monthYearOptions" 
            :allow-empty="true"
            :searchable="true"
          />
        </b-col>
        <b-col cols="2" class="p-0 d-flex pl-2">
          <BaseNewButton
              variant="secondary"
              :disabled="!hasFilterFilled"
              @click.prevent="handleClearFilters"
            >
              {{ $t("common.text_0003") }}
          </BaseNewButton>
        </b-col>
        <b-col cols="4" class="p-0 d-flex flex-row-reverse">
            <BaseNewButton
              variant="primary"
              @click.prevent="exportData"
            >
              Exportar Tabela
          </BaseNewButton>
		  <UpcomingInvoicesExportModal :filters="exportFilter" />
        </b-col>
      </div>
      <!-- Filters -->
      <div class="container-x">
        <Container :title="$t('views.seller.reports.text_1444')"
          subtitle="">
          <div class="position-relative" style="min-height: 270px;">
            <b-skeleton-wrapper :loading="loading" style="top: 0; height: 270px;" class="bg-white mt-3 rounded-lg d-flex align-items-center w-100">
              <template #loading>
                <div class="w-100 h-100 mb-2 d-flex align-items-center flex-column">
                  <b-skeleton class="mb-2" width="80%" height="80%"></b-skeleton>
                  <div class="mt-2 d-flex justify-content-center align-items-center w-100" style="gap: 5px;">
                    <b-skeleton class="mb-1" width="10%" ></b-skeleton>
                    <b-skeleton class="mb-1" width="10%" ></b-skeleton>
                    <b-skeleton class="mb-1" width="10%" ></b-skeleton>
                  </div>
                </div>
              </template>
            </b-skeleton-wrapper>
            <BarChartData 
              :data="bar_chart_data['data'] || []" 
              :labels="bar_chart_data['labels'] || []"
              :data_line="line_chart_data['data'] || []" 
              :labels_line="line_chart_data['labels'] || []" 
              :title="'Total'"
              :loading="loading" />
          </div>
        </Container>
        <div class="box-stateless">
          <div class="position-relative">
            <TableSummary
            subtitle="Receitas estimadas para os próximos 12 meses. Cada linha da tabela representa um mês e mostra a receita projetada."
            subtitle-warning="Projeção não contempla inadimplência, reembolso e chargeback."
            :total="next_12_months_sales_summary"
            :subtotal="next_12_months_sales_count">
            </TableSummary>
            <b-skeleton-wrapper :loading="loading" style="top: 0" class="bg-white mt-3 rounded-lg position-absolute d-flex px-4 align-items-end w-100">
              <template #loading>
                <div class="w-100 mb-2">
                  <b-skeleton class="my-2" width="60%"></b-skeleton>
                  <b-skeleton class="mb-2" width="80%"></b-skeleton>
                </div>
                <div class="w-100 mb-2 d-flex align-items-end flex-column">
                  <b-skeleton class="mb-2" width="30%" height="50%"></b-skeleton>
                  <b-skeleton class="mb-1" width="40%" ></b-skeleton>
                </div>
              </template>
            </b-skeleton-wrapper>
          </div>
          <TableReport :columns="table_columns" :isLoading="loading" :rows="data"/>
        </div>
      </div>
  
      <!-- Modal Filters -->
      <b-modal
        v-model="showFilters" 
        content-class="font-inter px-4"
        body-class="p-0"
        size="lg"
        hide-footer 
        hide-header centered
      >
        <div class="d-flex flex-column" style="gap: 48px">
          <div class="d-flex flex-column" style="gap: 24px">
            <h5 class="modal-title">{{ $t("common.text_0001") }}</h5>
            <b-row>
              <b-col cols="6">
                <BaseSearchSelect
                  v-model="modalFilters.monthYear"
                  inputLabel="Mês/ano"
                  name="monthYear"
                  label="name"   
                  track-by="id"
                  deselect-label=""
                  selectLabel=""
                  selectedLabel=""
                  :options="monthYearOptions" 
                  :placeholder="$t('common.text_0004')"
                  :allow-empty="true"
                  :searchable="true"
                />
              </b-col>
              <b-col cols="6">
                <BaseInput 
                  :label="$t('views.seller.reports.text_1433')"
                  :placeholder="$t('views.seller.reports.text_1439')"
                  v-model="modalFilters.salesQtd"
                  v-mask="['#########']"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <BaseMoneyInput
                  :label="$t('views.seller.reports.text_1434')"
                  v-model="modalFilters.creditCard"
                  v-bind="moneyConfig"
                />
              </b-col>
              <b-col cols="6">
                <BaseMoneyInput
                  :label="$t('views.seller.reports.text_1435')"
                  v-model="modalFilters.boleto"
                  v-bind="moneyConfig"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <BaseMoneyInput
                  :label="$t('views.seller.reports.text_1436')"
                  v-model="modalFilters.international"
                  v-bind="moneyConfig"
                />
              </b-col>
              <b-col cols="6">
                <BaseMoneyInput
                  :label="$t('views.seller.reports.text_1437')"
                  v-model="modalFilters.grossValue"
                  v-bind="moneyConfig"
                />
              </b-col>
            </b-row>
          </div>
  
          <div class="d-flex justify-content-end p-0" style="gap: 12px; margin: 0;">
            <BaseNewButton
              variant="secondary"
              type="button"
              @click="showFilters = false"
            >
              {{ $t("common.text_0002") }}
            </BaseNewButton>
            <BaseNewButton
              variant="secondary"
              :disabled="!hasFilterFilled"
              @click.prevent="handleClearFilters"
            >
              {{ $t("common.text_0003") }}
            </BaseNewButton>
            <BaseNewButton
              variant="primary"
              type="button"
              @click="handleApplyFilters"
              :disabled="!hasFilterFilled"
            >
              {{ $t("common.text_0005") }}
            </BaseNewButton>
          </div>
        </div>
      </b-modal>
      <!-- Modal Filters -->
    </div>
  </template>
  
  <script>
  import moment from 'moment-timezone';
  import { Money } from 'v-money';
  
  import Multiselect from 'vue-multiselect';
  import DateRangePicker from 'vue2-daterange-picker';
  
  import _ from 'lodash';
  
  import ReportService from '@/services/resources/ReportService';
  import ProductService from '@/services/resources/ProductService';
  
  import BaseHeader from '@/components/BaseHeader.vue';
  import Container from '@/components/Seller/Reports/Container.vue';
  import Table from '@/components/Seller/Reports/Table.vue';
  import TableReport from "@/components/Seller/Reports/TableReport.vue";
  import BarChartData from '@/components/Seller/Reports/BarChartData.vue';
  import BaseSearchSelect from '@/components/BaseSearchSelect.vue';
  import BaseInput from '../../../components/BaseInput.vue';
  import TableSummary from "@/components/Seller/Reports/TableSummary.vue";
  import UpcomingInvoicesExportModal from '@/components/Seller/Reports/modals/UpcomingInvoicesExportModal.vue';
  
  const Report = ReportService.build();
  const productService = ProductService.build();
  
  moment.locale('pt-br');
  
  export default {
    components: {
      BaseHeader,
      Container,
      Table,
      BarChartData,
      Multiselect,
      DateRangePicker,
      Money,
      TableSummary,
      UpcomingInvoicesExportModal,
      TableReport,
    },
    data() {
      return {
        data: [],
        loading: false,
        bar_chart_data: [],
        line_chart_data: [],
        productsOptions: [],
        selectedProducts: [],
        loadingProducts: false,
        showFilters: false,
        monthYearOptions: [],
        moneyConfig: {
          decimal: ",",
          thousands: ".",
          prefix: "R$ ",
          suffix: "",
          precision: 2,
          masked: false,
        },
        filterSearch: {
          products: [],
          startDate: moment.tz('America/Sao_Paulo').subtract(12, 'months').format('YYYY-MM-DD'),
          endDate: moment.tz('America/Sao_Paulo').add(2, 'months').endOf('month').format('YYYY-MM-DD'),
          monthYear: '',
          creditCard: '',
          boleto: '',
          international: '',
          grossValue: '',
          salesQtd: ''
        },
        modalFilters: {
          monthYear: null,
          creditCard: '',
          boleto: '',
          international: '',
          grossValue: '',
          salesQtd: ''
        },
        initialDateRange: {
          startDate: moment.tz('America/Sao_Paulo').subtract(12, 'months'),
          endDate: moment.tz('America/Sao_Paulo').add(2, 'months').endOf('month'),
        },
        dateRange: {
          startDate: moment.tz('America/Sao_Paulo').subtract(12, 'months'),
          endDate: moment.tz('America/Sao_Paulo').add(2, 'months').endOf('month'),
        },
        localeDate: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
          monthNames: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez',
          ],
          firstDay: 0,
        },
        next_12_months_sales_summary: "R$ 0",
        next_12_months_sales_count: "0",
        table_columns: [
          { name: this.$t('views.seller.reports.text_1432'), type: 'text', fieldName: 'month_year' },
          { 
            name: this.$t('views.seller.reports.text_1433'), 
            fieldName: 'sales', 
            render: (value, row) => 
              `<a class="link-table" target="_blank" href="/relatorios/potencial_receita/detalhes?month_year=${row.month_year}">${value}</a>`
          },
          { name: this.$t('views.seller.reports.text_1434'), type: 'text', fieldName: 'credit_card', tooltip: this.$t('views.seller.reports.text_1462') },
          { name: this.$t('views.seller.reports.text_1435'), type: 'email', fieldName: 'boleto', tooltip: this.$t('views.seller.reports.text_1467') },
          { name: this.$t('views.seller.reports.text_1436'), type: 'text', fieldName: 'international', tooltip: this.$t('views.seller.reports.text_1468') },
          { name: this.$t('views.seller.reports.text_1437'), type: 'text', fieldName: 'total_amount' }
        ]
      };
    },
    computed: {
      hasFilterFilled() {
        if (this.filterSearch.monthYear || this.filterSearch.products.length) {
          return true;
        }
        return false;
      },
      exportFilter() {
        return {
            ...this.filterSearch,
          monthYear: this.filterSearch.monthYear.id || '',
        }
      },
      dateRanges() {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
  
        let yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);
  
        let lastWeek = new Date();
        lastWeek.setDate(today.getDate() - 7);
        lastWeek.setHours(0, 0, 0, 0);
  
        return {
          [this.$t("locale_date.today")]: [today, today],
          [this.$t("locale_date.yesterday")]: [yesterday, yesterday],
          [this.$t("locale_date.last_week")]: [lastWeek, today],
          [this.$t("locale_date.current_month")]: [
            new Date(today.getFullYear(), today.getMonth(), 1),
            new Date(today.getFullYear(), today.getMonth(), 30),
          ],
          [this.$t("locale_date.current_year")]: [
            new Date(today.getFullYear(), 0, 1),
            new Date(today.getFullYear(), 11, 31),
          ],
          [this.$t("locale_date.last_month")]: [
            new Date(today.getFullYear(), today.getMonth() - 1, 1),
            new Date(today.getFullYear(), today.getMonth(), 0),
          ],
          [this.$t("locale_date.every_period")]: [
            new Date(2020, 0, 1),
            new Date(today.getFullYear(), today.getMonth(), today.getDate()),
          ],
        };
      },
    },
    watch: {
      selectedProducts: function (products) {
        this.filterSearch.products = [products.id];
      },
      filterSearch: {
        handler: function () {
          this.fetchData();
        },
        deep: true,
      },
    },
    methods: {
      exportData(){
        this.$bvModal.show('upcoming-invoices-export');
      },
      fetchData() {
        this.loading = true;
        const filters = {
          ...this.filterSearch,
          monthYear: this.filterSearch.monthYear.id || '',
        };
  
        Report.search({ 
          url: 'upcoming-invoices',
          ...filters,
          type: 'full' 
        })
          .then((response) => {
            this.data = response['sales_grouped_by_month_table'];
            this.bar_chart_data = response['sales_grouped_by_month_bar_chart'];
            this.line_chart_data = response['sales_grouped_by_month_line_chart'];
            this.next_12_months_sales_summary = response['next_12_months_sales_summary'];
            this.next_12_months_sales_count = 'Total de Vendas: ' + response['next_12_months_sales_count'];
            this.loading = false;
  
            if (!this.monthYearOptions.length && this.data.length) {
              this.monthYearOptions = this.data.map(item => ({
                id: moment(item.month_year, 'MMM/YYYY', 'pt').format('YYYY-MM'),
                name: item.month_year
              }));
            } 
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
          });
      },
      async fetchProducts(search = null) {
        try {
          this.loadingProducts = true;
  
          const data = {
            list: true,
            with_participants: true,
          };
  
          if (search) {
            data.search = search;
          }
  
          const products = await productService.search(data);
  
          if (!products.length) {
            return [];
          }
          this.productsOptions = products.map(({ id, name }) => ({ id, name }));
        } catch (error) {
          this.productsOptions = [];
          console.log('PotentialRevenue::fetchProducts', error);
        } finally {
          this.loadingProducts = false;
        }
      },
      searchProducts: _.debounce(async function (search) {
        await this.fetchProducts(search);
      }, 500),
      dateRanger(dateRange) {
        let end = moment(dateRange.endDate);
        let start = moment(dateRange.startDate);
  
        this.totalDiffDays = end.diff(start, 'days') + 1;
  
        let startDate = moment
          .tz(dateRange.startDate, 'America/Sao_Paulo')
          .format('YYYY-MM-DD');
        let endDate = moment
          .tz(dateRange.endDate, 'America/Sao_Paulo')
          .format('YYYY-MM-DD');
        this.filterSearch = { ...this.filterSearch, startDate, endDate };
      },
      handleApplyFilters() {
        this.filterSearch = { ...this.filterSearch, ...this.modalFilters };
  
        if (this.modalFilters.monthYear && this.modalFilters.monthYear.id) {
          this.filterSearch.monthYear = this.modalFilters.monthYear.id;
        }
        this.showFilters = false;
      },
      handleClearFilters() {
        Object.assign(this.modalFilters, {
          ...Object.fromEntries(Object.keys(this.modalFilters).map(key => [key, ''])),
          monthYear: ''
        });
        Object.assign(this.filterSearch, {
          ...Object.fromEntries(Object.keys(this.filterSearch).map(key => [key, ''])),
          ...{
            startDate: this.initialDateRange.startDate.format('YYYY-MM-DD'),
            endDate: this.initialDateRange.endDate.format('YYYY-MM-DD'),
            products: []
          }
        });
  
        this.dateRange = {
          startDate: this.initialDateRange.startDate.toDate(),
          endDate: this.initialDateRange.endDate.toDate()
        };
        this.monthYearOptions = [];
        this.selectedProducts = [];
      }
    },
    mounted() {
      this.fetchData();
    }
  };
  </script>
  
  <style scoped>
  .box-stateless {
    border: 1px solid #D7DAE2;
    box-sizing: border-box;
    border-radius: 8px;
  }
  
  .container-x {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 24px;
  }
  </style>
  <style>
  .box-stateless {
    table thead tr th:first-child {
      border-top-left-radius: 8px;
    }
  
    table thead tr th:last-child {
      border-top-right-radius: 8px;
    }
  }
  
  .date-range-picker-container .reportrange-text {
    padding: 0 !important;
    height: 38px !important;
    display: flex; 
    align-items: center;
    padding: 0px 12px !important;
  }
  
  .date-range-picker-container .vue-daterange-picker {
    width: 100%;
  }
  
  .potential-revenue-filters .modal-dialog.modal-md {
    min-width: 635px !important;
    font-family: var(--Default-font-family);
  }
  
  .potential-revenue-filters .modal-body {
    padding: 0 !important;
  }
  .link-table {
    color: var(--Default-primary-800, #0854C5);

    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-decoration: none;
    }
  
  </style>